'use strict';

exports.__esModule = true;

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _Sandbox = require('../Sandbox');

var _Sandbox2 = _interopRequireDefault(_Sandbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isSandbox = function isSandbox(obj) {
  return (0, _isObject2.default)(obj) && obj instanceof _Sandbox2.default;
};

exports.default = isSandbox;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/utils/isSandbox.js
// module id = ifX4
// module chunks = 0